import Navbar from "../components/Navbar";
import Chapter6thongtin from "./Chapter6thongtin";
function Chapter6(){
    return(
        <>
        <Navbar/>
        <Chapter6thongtin/>
        </>
    )
}
export default Chapter6;